<app-metadata [graphName]="'social-investments'"></app-metadata>
<button mat-raised-button color="primary" (click)="addSocialInvestment()" i18n="add social investment@@add_social_investment">Add Social Investment</button>
@if (data && helptexts &&informations) {
  <div>
    @for (datum of data; track datum) {
      <app-form
        [informations]="informations"
        [data]="datum"
        [helptexts]="helptexts[0]"
        [showDelete]="true"
        (deleted)="deleteSocialInvestment($event)"
        (dataSubmitted)="onData($event)"
      ></app-form>
    }
  </div>
}
